/* stylelint-disable */
.favorites-button__container {
  display: flex;
  align-items: center;
  padding: 0;
  border: none;
  outline: none;
  background: transparent;
  color: #42b4e6;
  --qds-control-hero-border-radius: var(--qds-control-border-radius);
  --qds-control-hero-text: var(--qds-control-standard-text);
  --qds-control-hero-gap-internal: var(--qds-control-standard-gap-internal);
  --qds-control-hero-padding-auto-height: var(--qds-control-standard-padding-auto-height);
  --qds-control-button-hero-padding-horizontal: var(--qds-control-button-standard-padding-horizontal);
}

.favorites-button__container:hover {
  cursor: pointer;
}